
import {ComputedRef, ref} from "vue";
import {authenticationUseCases} from "../../../../domain/usecase/impl/authenticationUseCases";
import store from "../../../repository/store/store";
import router from "../../../../src/routes";
import ModernInput from "../application/forms/modernInput.vue";
import InputPassword from "../application/forms/InputPassword.vue";
import {computed} from "@vue/reactivity";
import {dispatchErrorBox} from "../mixins";
import {RepositoryException} from "../../../../domain/exceptions/exceptions";

export default {
  name: "EmailVerification",
  components: { ModernInput, InputPassword },

  setup(_) {
    const password = ref("");
    const confirmation = ref("");
    const currentType = ref("password");
    const passwordPattern =
      "(?=^.{8,}$)((?=.*\\d)|(?=.*\\W+))(?![.\\n])(?=.*[A-Z])(?=.*[a-z]).*$";
    const passwordPatternTitle = ref(
      "" +
        "Sua senha deve conter: " +
        "Ao menos 8 caracteres, \n" +
        "uma letra minúscula, \n" +
        "uma letra maiúscula, \n" +
        "um caractere especial \n"
    );

    async function resetPassword() {
      const token = String(router.currentRoute.value.params.token);
      const recoveryType = router.currentRoute.value.params.resetBy;
      password.value = password.value.trim();
      confirmation.value = confirmation.value.trim();
      try {
        if (recoveryType === "email") {
          await authenticationUseCases.resetPasswordByEmail(
            password.value,
            confirmation.value,
            token
          );
        } else {
          await authenticationUseCases.resetPasswordByData(
            password.value,
            confirmation.value,
            token
          );
        }
        await store.dispatch("miscellany_module/setSuccess", {
          message: "Senha alterada com sucesso!",
          changed: true
        });
        await router.push({ name: "home" });
      } catch (e) {
        if (e instanceof RepositoryException) {
          await dispatchErrorBox(e.message);
        } else {
          console.error(e);
          await dispatchErrorBox("Ocorreu um erro inesperado.");
        }
      }
    }

    const togglePasswordVisibility = async isVisible => {
      currentType.value = isVisible ? "text" : "password";
    };

    const isPasswordVisible: ComputedRef<boolean> = computed(() => {
      return store.getters["authentication_module/isPasswordVisible"];
    });

    return {
      currentType,
      password,
      confirmation,
      isPasswordVisible,
      passwordPattern,
      passwordPatternTitle,
      resetPassword,
      togglePasswordVisibility
    };
  }
};
